import axios from "axios";

import { toastify } from "../components/common/notification";

import { url } from ".";

import { LogParam } from "../types/logParam";
import { errorMessage } from "../utils/common";
import { logError, logInfo } from "../utils/logger";

// always set function name and message for every executable block
// data is optional
const logParams : LogParam = {
  applicationName : "Orchestrator Client",
  screenModuleName: "client\\src\\controllers\\notification.ts",
  functionName: "",
  message: "",
}

type EventActionT = {
  critical: boolean,
  inApp: boolean,
  emailAddress: string
}

export type CreateNotificationConfigT = {
    organization_id: string
    license_usage_notification: EventActionT,
    task_execution_started: EventActionT,
    task_execution_stopped: EventActionT,
    task_execution_failed: EventActionT,
    task_execution_skipped: EventActionT,
    task_execution_completed: EventActionT,
    agent_status_deactivated: EventActionT,
    agent_status_activated: EventActionT,
    agent_status_deployed: EventActionT,
    agent_status_undeploy: EventActionT,
    agent_status_connected_to_other_machine: EventActionT,
}


export const createNotificationConfig = (token: string, data: CreateNotificationConfigT) =>
  axios
.post(`${url}/notification/createNotificationConfig`, data, {
  headers: {
    authorization: `Bearer ${token}`,
    },
    })
    .then((res) => {
        logParams.functionName = "createNotificationConfig";
        logParams.message = "Retrieved notification config and posted";
        logInfo(logParams);
        return res.data; 
      })
      .catch((err) =>
      {
        logParams.functionName = "createNotificationConfig";
        logParams.message = errorMessage(err);
        logError(logParams);
  
        toastify(
          "failure",
          err.response.data.message.length > 0
            ? err.response.data.message
            : "error while creating notification config"
        )}
      );
    
export const getNotificationConfig = (token: string, organization_id: string) =>
    axios
        .post(`${url}/notification/getNotificationConfig`, {organization_id: organization_id}, {
        headers: {
            authorization: `Bearer ${token}`,
        },
        })
        .then((res) => {
        logParams.functionName = "getNotificationConfig";
        logParams.message = "Retrieved notification config and posted";
        logInfo(logParams);
        return res.data; 
        })
        .catch((err) =>
        {
        logParams.functionName = "getNotificationConfig";
        logParams.message = errorMessage(err);
        logError(logParams);
    
        toastify(
            "failure",
            "error while getting notification config"
        )}
        );
    
export const getNotificationMessage = (token: string) =>
  axios
      .get(`${url}/notification/getNotificationMessage`, {
      headers: {
          authorization: `Bearer ${token}`,
      },
      })
      .then((res) => {
      logParams.functionName = "getNotificationMessage";
      logParams.message = "Retrieved notification message and posted";
      logInfo(logParams);
      return res.data; 
      })
      .catch((err) =>
      {
      logParams.functionName = "getNotificationMessage";
      logParams.message = errorMessage(err);
      logError(logParams);
    }
      );

export const clearAllNotificationMessage = (token: string) =>
  axios
      .put(`${url}/notification/clearAll`, undefined, {
      headers: {
          authorization: `Bearer ${token}`,
      },
      })
      .then((res) => {
      logParams.functionName = "clearAllNotificationMessage";
      logParams.message = "cleared all notification message";
      logInfo(logParams);
      return res.data; 
      })
      .catch((err) =>
      {
      logParams.functionName = "clearAllNotificationMessage";
      logParams.message = errorMessage(err);
      logError(logParams);
    }
      );


export const viewedAllNotificationMessage = (token: string) =>
  axios
      .put(`${url}/notification/viewed`, undefined, {
      headers: {
          authorization: `Bearer ${token}`,
      },
      })
      .then((res) => {
      logParams.functionName = "viewedAllNotificationMessage";
      logParams.message = "viewed all notification message";
      logInfo(logParams);
      return res.data; 
      })
      .catch((err) =>
      {
      logParams.functionName = "viewedAllNotificationMessage";
      logParams.message = errorMessage(err);
      logError(logParams);
    }
      );